import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {AffichageCGUService} from '../services/affichage-cgu.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {UserWVO} from '../models/UserWVO';
import {MessageService} from 'primeng/api';
import {AuthentificationService} from '../../../services/auth/authentification.service';
import * as FileSaver from 'file-saver';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { ConfigurationService } from 'src/app/services/configuration.service';
@Component({
  selector: 'app-affichage-cgu',
  templateUrl: './affichage-cgu.component.html',
  styleUrls: ['./affichage-cgu.component.scss']
})
export class AffichageCguComponent implements OnInit {
  private isMobile: boolean=false;
  @ViewChild('pdfViewer') pdfViewer: ElementRef;
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    this.AuthServ.clearAccessStorage();
    this.router.navigate(['/auth/login']);
  }
  typeDocumentRgpd = 'CGU_CONSENTEMENT';
  fileURL = '';
  file: any;
  user: UserWVO;
  User: Subscription;
  newUser: UserWVO;
  showSpinner = false;
  Regle1 = false;
  Regle2 = false;
  toggleBool = true;
  disabledCheckBox = true;
  title1Hidden=true;
  title2Hidden=true;
  zoom=null;
  statuCgu=null;
  typeUser:string;
  access=null;
  /** Gestion d'affichage regle1 */
  protected showAcceptationCguRegle1=this.configurationService.get().ACCEPTATION_CGU.SHOW_REGLE1;
  /** Gestion d'affichage regle2 */
  protected showAcceptationCguRegle2=this.configurationService.get().ACCEPTATION_CGU.SHOW_REGLE2;

  constructor(private configurationService: ConfigurationService, private readonly affichageCGUService: AffichageCGUService, private readonly translate: TranslateService, private readonly router: Router, private readonly messageService: MessageService,private readonly AuthServ:AuthentificationService, private cookieService: CookieService) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use('fr');
  }

  ngOnInit(): void {
    this.access = this.AuthServ.getStoredAccess();
    this.statuCgu = this.AuthServ.getStatusCgu();
    this.typeUser = this.AuthServ.getTypeUser();
    this.zoom=80;
    this.initCheckAcceptationCgu();
    if(this.typeUser!=='ADMIN') {
    if (history.state.data) {
      this.handleDataState();

    } else if (history.state.test) {
      this.handleTestState();

    } else if (
      this.access != null &&
      this.statuCgu === '-1'
    ) {
      this.handleAccessCguCase(true);
    } else if (
      this.access != null &&
      this.statuCgu === '1'
    ) {
      this.handleAccessCguCase(false);
    }
    else if (this.access != null &&
      this.statuCgu === '0'){
      this.router.navigate(['/accueil']);

    } else {
      this.AuthServ.clearAccessStorage();
      this.router.navigate(['/auth/login']);
    }
    }
    else {
      this.AuthServ.clearAccessStorage();
      this.router.navigate(['/accueil']);
    }
    this.isMobile = window.innerWidth < 768;
  }

  private initCheckAcceptationCgu()
  {
    if(!this.showAcceptationCguRegle1)
      this.Regle1=true;
    if(!this.showAcceptationCguRegle2)
      this.Regle2=true;
  }
  private handleDataState(): void {
    this.title1Hidden = true;
    this.title2Hidden = false;
    this.getFile();
    history.state.data = null;
  }

  private handleTestState(): void {
    this.title1Hidden = false;
    this.title2Hidden = true;
    this.getFile();
    history.state.test = null;
  }

  private handleAccessCguCase(isOldRgbdDoc: boolean): void {
    this.title1Hidden = !isOldRgbdDoc;
    this.title2Hidden = isOldRgbdDoc;
    this.getFile();
  }
  getFile() {
    this.affichageCGUService.getPdf(this.typeDocumentRgpd).subscribe(res => {
      this.file = new Blob([res], {type: 'application/pdf'});
      const url = window.URL.createObjectURL(this.file);
      this.fileURL = url;
    });
  }

  updateStatusCgu(statusCGU: boolean) {
    this.User = this.affichageCGUService.updateStatusCgu(statusCGU).subscribe(result => {
      this.newUser = result;
    }, error => {
    });
  }

  accepter() {
    this.updateStatusCgu(true);
    this.cookieService.set('StatusCgu','0', null, null, null, true);
    this.router.navigateByUrl('/accueil');
  }

  refuser() {
    this.updateStatusCgu(false);
    this.AuthServ.clearAccessStorage();
    this.router.navigate(['/auth/login']);
  }

  onCheckboxRegle1(event: any) {

    if (event.target.checked) {
      this.Regle1 = true;
      if (this.Regle1 && this.Regle2) {
        this.toggleBool = false;
      }
    } else {
      this.Regle1 = false;
      this.toggleBool = true;
    }
  }

  onCheckboxRegle2(event: any) {
    if (event.target.checked) {
      this.Regle2 = true;
      if (this.Regle1 && this.Regle2) {
        this.toggleBool = false;
      }
    } else {
      this.Regle2 = false;
      this.toggleBool = true;
    }
  }
  downloadDocument(): void {
    this.affichageCGUService.getPdf(this.typeDocumentRgpd)
      .subscribe((blob: Blob): void => {
        const file = new Blob([blob], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        FileSaver.saveAs(fileURL, 'cgu_pdf');
      });
  }

  onPageChange(event: any) {
    if (this.totalPages === event || (this.isMobile && this.totalPages === event + 1)) {
     this.disabledCheckBox=false;
    }
  }

  totalPages = 0;

  onPdfLoadComplete(event: any) {
    this.totalPages = event.pagesCount;
    if (this.totalPages === 1) {
      this.zoom=75;
      this.disabledCheckBox=false;
    }
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    //Resized window
    this.isMobile = window.innerWidth < 768; // Définissez la largeur de l'écran pour le mode mobile
  }
}


